/** Canonical production origin — used for SEO, OG URLs, analytics page_location */
export const SITE_URL = 'https://figtures.com';
export const SITE_NAME = 'Figtures';

/** Build absolute URL for OG / JSON-LD (Vite asset imports resolve to /assets/...). */
export function absoluteUrl(pathOrAsset: string): string {
  if (!pathOrAsset) return SITE_URL;
  if (pathOrAsset.startsWith('http://') || pathOrAsset.startsWith('https://')) return pathOrAsset;
  const path = pathOrAsset.startsWith('/') ? pathOrAsset : `/${pathOrAsset}`;
  return `${SITE_URL}${path}`;
}
